package empiresmp.feature.gallery.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import empiresmp.components.FlowRow
import empiresmp.components.layouts.PageLayout
import empiresmp.components.navbar.EmpireSmpDesktopNavBar
import empiresmp.feature.gallery.di.GalleryModule
import empiresmp.feature.gallery.model.GalleryItem
import kotlinx.browser.document
import kotlinx.browser.window
import ru.astrainteractive.klibs.paging.state.PageResult
import ru.astrainteractive.klibs.paging.util.loadNextPage
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette

@Composable
fun BottomReachedEffect(vararg key: Any, block: () -> Unit) {
    val isEndReached = fun(): Boolean {
        val scrolledTo = window.innerHeight + window.scrollY
        val isReachBottom = (document.body?.scrollHeight ?: 0) >= scrolledTo.toInt()
        println("isReachBottom: $isReachBottom; scrollheight: ${document.body?.scrollHeight}; scrolledTo: $scrolledTo")
        return isReachBottom
    }
    document.onscroll = {
        if (isEndReached.invoke()) block.invoke()
    }
    LaunchedEffect(key) {
        if (isEndReached.invoke()) block.invoke()
    }
}

@Composable
fun GalleryPageContent() {
    val galleryModule = GalleryModule()
    val viewModel = remember { galleryModule.createGalleryViewModel() }
    DisposableEffect(viewModel) {
        onDispose { viewModel.dispose() }
    }
    val state by viewModel.paging.state.collectAsState()
    var selectedGalleryItemDialog by remember { mutableStateOf<GalleryItem?>(null) }
    val theme = LocalSitePalette.current

    BottomReachedEffect(state.pageResult) {
        viewModel.loadNextPage()
    }

    PageLayout {
        EmpireSmpDesktopNavBar()
        Column {
            FlowRow {
                state.items.forEach { item ->
                    GalleryItemComposable(
                        item = item,
                        onClick = {
                            selectedGalleryItemDialog = item
                        }
                    )
                }
            }
            when (state.pageResult) {
                is PageResult.Failure -> Unit
                PageResult.LastPage -> Unit
                PageResult.Loading -> Unit
                PageResult.Pending -> Unit
            }
        }
        GallerModalComposable(
            item = selectedGalleryItemDialog,
            onClose = { selectedGalleryItemDialog = null }
        )
    }
}
